<template>
      <div>
        <button @click="closethis()" class="ui right floated icon button">
          <i class="close icon"></i>
        </button>
        <div class="resp-container">
          <iframe type="application/pdf" allowfullscreen class="resp-iframe" :src="srcPdf">
            <a :href="srcPdf" download="Boleto.pdf">Baixar</a>
          </iframe>
        </div>
      </div>
</template>

<script>
export default {
  props: ["pdfFile", "email"],
  components: {},
  mounted() {
    this.srcPdf = `data:application/pdf;base64,${this.pdfFile}`
  },
  data() {
    return {
      srcPdf: ""
    };
  },
  methods: {
    closethis() {
      this.$emit("close", "");
    }
  }
};
</script>

<style>
.resp-container {
  position: relative;
  overflow: hidden;
  padding-top: 200%;
}
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>